<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="m-5">
    <h1 class="display-1 mb-5"
        i18n>
        Organizations
    </h1>
    <app-data-table-ajax columnMode="force"
                         url="/roles/scopes/2"
                         limit="26"
                         [columns]="columns"
                         (rowClicked)="onSelectRow($event)">
    </app-data-table-ajax>
</div>



// WEBPACK FOOTER //
// ./src/app/access-management/organizations/organizations-list/organizations-list.component.html